import Calendar from './calendar';

export default Calendar;


// WEBPACK FOOTER //
// ./src/components/calendar/index.js